import { makeRequest } from 'utils/requestLogger';

export default (notificationIds) =>
  makeRequest('put', '/api/notifications/mark_as_seen', {
    notification_ids: notificationIds,
  });



// WEBPACK FOOTER //
// ./src/app/services/account/markNotifications.js